
























import Vue, { PropType } from 'vue';
import Spinner from '@/components/Spinner/Spinner.vue';

export default Vue.extend({
    name: 'Button',

    components: { Spinner },

    props: {
        disabled: Boolean,
        loading: Boolean,
        type: {
            type: String,
            default: 'button',
        },
        modifiers: Array as PropType<string[]>,
    },

    computed: {
        _modifiers(): { [key: string]: boolean } {
            return this.modifiers?.reduce(
                (prev, modifier) => ({ ...prev, ['btn--' + modifier]: true }),
                {} as { [key: string]: boolean }
            );
        },
    },
});
